module.exports = "<div class=\"heading-title\" [ngClass]=\"\">\r\n  <h3 class=\"title iq-tw-7\">{{ title }}</h3>\r\n  <p>{{ subTitle }}</p>\r\n</div>\r\n"